interface SocialShareProps {
  title: string;
  url: string;
}

export default function SocialShare({ title, url }: SocialShareProps) {
  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(url);

  const shareLinks = [
    {
      name: "WhatsApp",
      icon: "ri-whatsapp-line",
      color: "bg-green-500 hover:bg-green-600",
      url: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
    },
    {
      name: "Facebook",
      icon: "ri-facebook-circle-line",
      color: "bg-blue-600 hover:bg-blue-700",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      name: "X",
      icon: "ri-twitter-x-line",
      color: "bg-gray-800 hover:bg-gray-900",
      url: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
    },
    {
      name: "Telegram",
      icon: "ri-telegram-line",
      color: "bg-sky-500 hover:bg-sky-600",
      url: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
    },
  ];

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-alvinegro-muted mr-1">Compartilhar:</span>
      {shareLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.name}
          className={`w-8 h-8 rounded-full flex items-center justify-center text-white transition-colors ${link.color}`}
        >
          <i className={`${link.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
        </a>
      ))}
    </div>
  );
}